import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ImageAsset } from '../models/image-asset.model';
import { ImageAssetApiService } from '../services/image-asset-api.service';

@Injectable()
export class ImageManagerService
{
    constructor(private imageAssetApiService: ImageAssetApiService) { }

    getImageAsset(imageAssetId: number): Observable<ImageAsset>
    {
        return this.imageAssetApiService.getImageAsset(imageAssetId);
    }

    getImageWithResolution(imageAssetId: number, width: number, height: number): Observable<Blob>
    {
        return this.imageAssetApiService.getImageWithResolution(imageAssetId, width, height);
    }

    uploadImage(imageFile: File)
    {
        const formData = new FormData();
        formData.append('imageFile', imageFile, imageFile.name);
        return this.imageAssetApiService.uploadImage(formData);
    }

    getControllerImage(): Observable<ImageAsset>
    {
        return this.imageAssetApiService.getControllerImage()/*
            .pipe(
                switchMap((file: File) => this.uploadImage(file))
            ); */

    }

}
